import * as React from "react";
import type { SVGProps } from "react";
const SvgBellOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M20.418 16.599c-.601-.885-1.185-2.189-1.185-3.76l.026-2.151c0-4.265-3.227-7.723-7.206-7.723q-.644 0-1.255.118M9.229 20.66c.75.585 1.739.941 2.824.941s2.074-.356 2.823-.941m1.13-3.012H4.119c-.446 0-.695-.686-.425-1.067.626-.884 1.231-2.18 1.231-3.742l.026-2.262c0-1.814.592-3.48 1.58-4.788m11.733 14.683L5.276 2.4"
    />
  </svg>
);
export default SvgBellOff01;
